import '@take-2/assets/javascripts/shared/global/babel-polyfill.js';
